module.exports = __webpack_public_path__ + "static/media/eng_d_2487.04a5e949.vtt";